module.exports = __webpack_public_path__ + "img/ranger.20503a90.png";